<div
  class="modern-input-wrapper"
  [class.invalid]="isInvalid"
  [class.description-field]="label === 'Event Description'"
  [class.focused]="dropdownOpen || isFocused"
  [class.input-disabled]="disabled"
>
  <div [ngClass]="labelGap ? 'input-container-3' : 'input-container'">
    <label
      *ngIf="label"
      [ngClass]="{
        'Normal-label': context === 'Normal',
        'floating-label': context === 'default',
        'disabled-label': disabled,
        'label-gap': labelGap && context === 'Normal',
      }"
    >
      {{ label }}
      <span *ngIf="required" class="req-star">*</span>
    </label>

    <div
      *ngIf="subLabel !== ''"
      class="sub-label"
      [class.disabled-sub-label]="disabled"
    >
      {{ subLabel }}
    </div>

    <!-- From-To Time Selector -->
    <div *ngIf="type === 'time'" class="from-to-time-container">
      <app-drum-time-picker
        class="time-container"
        label="From"
        [value]="fromTimeDisplay"
        [disabled]="disabled"
        placeholder="HH:MM"
        (timeChange)="onFromTimeChange($event)"
      >
      </app-drum-time-picker>

      <div class="time-separator">to</div>

      <app-drum-time-picker
        class="time-container"
        label="To"
        [value]="toTimeDisplay"
        [disabled]="disabled"
        placeholder="HH:MM"
        (timeChange)="onToTimeChange($event)"
      >
      </app-drum-time-picker>
    </div>

    <!-- Standard Input except date/time/select/textarea -->
    <input
      *ngIf="
        type !== 'select' &&
        type !== 'search-select' &&
        type !== 'date' &&
        type !== 'textarea' &&
        type !== 'time'
      "
      [type]="type"
      [value]="value"
      [disabled]="disabled"
      [min]="type === 'date' ? todayDate : null"
      (input)="onInput($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
      class="input-field"
      [placeholder]="placeholder"
      [style.backgroundColor]="getBackgroundColor()"
    />

    <!-- Textarea Input -->
    <div *ngIf="type === 'textarea'" class="d-grid">
      <textarea
        *ngIf="type === 'textarea'"
        class="input-field textarea-field"
        [placeholder]="placeholder"
        [disabled]="disabled"
        [value]="value"
        (input)="onTextareaInput($event)"
        (focus)="onFocus()"
        (blur)="onBlur()"
        [rows]="lineRow"
        [style.backgroundColor]="getBackgroundColor()"
      ></textarea>

      <div *ngIf="type === 'textarea'" class="text-count">
        {{ (value?.length || 0) + " / " + textareaMaxLength }}
      </div>
    </div>

    <div
      *ngIf="type === 'date'"
      class="date-input-wrapper"
      (click)="!disabled && openCalendar()"
      [style.backgroundColor]="getBackgroundColor()"
    >
      <input
        #dateInputRef
        type="date"
        class="input-field date-field"
        [value]="value ? toInputDate(value) : ''"
        [placeholder]="placeholder || 'DD-MM-YYYY'"
        [disabled]="disabled"
        [min]="min"
        [max]="getResolvedMaxDate()"
        style="
          opacity: 0;
          position: absolute;
          z-index: -1;
          pointer-events: none;
        "
        tabindex="-1"
        readonly
      />

      <span
        class="formatted-date"
        [class.placeholder]="!formattedDate || formattedDate === ''"
      >
        {{ formattedDate || placeholder || "DD-MM-YYYY" }}
      </span>

      <span class="calendar-icon">
        <img src="assets/images/whitecalendar.svg" alt="calendar" />
      </span>
    </div>

    <app-custom-calendar
      *ngIf="showCalendar"
      [value]="value"
      [min]="min"
      [max]="getResolvedMaxDate()"
      [anchorRect]="calendarAnchorRect"
      [rangeStartDate]="rangeStartDate"
      [rangeEndDate]="rangeEndDate"
      [isEndDateCalendar]="isEndDateCalendar"
      [disableWeekends]="disableWeekends"
      [yearRangeList]="getCalendarYearRange()"
      [initialViewDate]="calendarInitialViewDate"
      (dateSelected)="onCalendarDateSelected($event)"
      (close)="closeCalendar()"
    >
    </app-custom-calendar>

    <div class="custom-select-wrapper" *ngIf="type === 'select'">
      <div
        class="custom-select-display"
        [class.invalid]="isInvalid"
        [style.backgroundColor]="getBackgroundColor()"
        (click)="!disabled && openDropdown()"
      >
        <div class="select-content">
          <input
            #searchInput
            class="select-label select-input"
            [placeholder]="placeholder || 'Select Option'"
            [(ngModel)]="searchText"
            (focus)="!disabled && onSearchInputFocus()"
            (input)="onSearchInput()"
            (keydown)="onSearchKeydown($event)"
            [disabled]="disabled"
            autocomplete="off"
            tabindex="0"
            [style.backgroundColor]="getBackgroundColor()"
          />
          <div class="select-icons">
            <span
              class="clear-button"
              *ngIf="value && !disabled"
              (click)="clearSelect($event)"
            >
              <img
                src="assets/images/cross-icon.svg"
                class="cross-icon"
                alt="clear"
              />
            </span>
            <svg
              class="arrow-icon"
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M6 9l6 6 6-6"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
      <div
        class="custom-options"
        #dropdownOptions
        *ngIf="dropdownOpen && !disabled"
        (click)="$event.stopPropagation()"
      >
        <div class="scrollable-options">
          <div
            class="custom-option"
            *ngFor="let option of filteredOptions; let i = index"
            [class.active]="i === selectedOptionIndex"
            (click)="selectOption(option.value)"
            style="display: grid"
          >
            {{ option.label }}
            <div
              style="font-size: 12px; color: #808080; font-weight: 400"
              *ngIf="option?.description"
            >
              {{ option?.description }}
            </div>
          </div>
        </div>
        <div
          *ngIf="showAddNew"
          class="custom-option add-option"
          [class.active]="selectedOptionIndex === filteredOptions.length"
          (click)="onAddNew()"
        >
          + {{ addNewText || "Add New" }}
        </div>
      </div>
    </div>

    <!-- Search Select Input -->
    <div
      class="custom-select-wrapper search-select-wrapper"
      *ngIf="type === 'search-select'"
    >
      <div
        class="custom-select-display"
        [class.invalid]="isInvalid"
        (click)="openDropdown()"
        [class.disabled]="disabled"
        [style.backgroundColor]="getBackgroundColor()"
      >
        <div class="select-content">
          <svg
            class="search-icon"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_d_3638_13599)">
              <path
                d="M11.25 15C14.9779 15 18 11.9779 18 8.25C18 4.52208 14.9779 1.5 11.25 1.5C7.52208 1.5 4.5 4.52208 4.5 8.25C4.5 11.9779 7.52208 15 11.25 15Z"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                opacity="0.4"
                d="M17.1963 15.5166C17.5938 16.7166 18.5013 16.8366 19.1988 15.7866C19.8363 14.8266 19.4163 14.0391 18.2613 14.0391C17.4063 14.0316 16.9263 14.6991 17.1963 15.5166Z"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <filter
                id="filter0_d_3638_13599"
                x="-1"
                y="0"
                width="26"
                height="26"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_3638_13599"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_3638_13599"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>

          <input
            #searchInput
            class="select-label select-input"
            [placeholder]="placeholder || 'Select Option'"
            [(ngModel)]="searchText"
            (focus)="onSearchInputFocus()"
            (input)="onSearchInput()"
            (keydown)="onSearchKeydown($event)"
            [disabled]="disabled"
            autocomplete="off"
            tabindex="0"
          />
          <div class="select-icons">
            <span
              class="clear-button"
              *ngIf="value"
              (click)="clearSelect($event)"
            >
              <img
                src="assets/images/cross-icon.svg"
                class="cross-icon"
                alt="clear"
              />
            </span>
          </div>
        </div>
      </div>

      <div
        *ngIf="showAddNew"
        class="custom-option add-option"
        [class.active]="selectedOptionIndex === filteredOptions.length"
        (click)="onAddNew()"
      >
        + {{ addNewText || "Add New" }}
      </div>

      <div
        class="custom-options"
        #dropdownOptions
        *ngIf="dropdownOpen"
        (click)="$event.stopPropagation()"
      >
        <div class="scrollable-options">
          <div
            class="custom-option"
            *ngFor="let option of filteredOptions; let i = index"
            [class.active]="i === selectedOptionIndex"
            (click)="selectOption(option.value)"
          >
            {{ option.label }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Error Messages -->
  <div
    class="error-message-container"
    [style.display]="
      errorMessage?.trim() && isInvalid && type !== 'time'
        ? 'block'
        : 'none'
    "
  >
    <div class="error-message">
      {{ errorMessage }}
    </div>
  </div>

  <div
    class="error-message-container"
    *ngIf="type === 'time' && shouldShowError()"
  >
    <div class="error-message" *ngIf="shouldShowError()">
      {{ getSingleErrorMessage() }}
    </div>
  </div>
</div>
